module.exports = __webpack_public_path__ + "static/logo-footer-409844978299053a2dbf3216b30d698c.svg";